import { render, staticRenderFns } from "./mallSolution.vue?vue&type=template&id=0a657b02&scoped=true&"
import script from "./mallSolution.vue?vue&type=script&lang=js&"
export * from "./mallSolution.vue?vue&type=script&lang=js&"
import style0 from "./mallSolution.vue?vue&type=style&index=0&id=0a657b02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a657b02",
  null
  
)

export default component.exports